package com.devi3east.bashbuddy.search.navigation

import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.search.ui.SearchRoute

fun NavGraphBuilder.searchNavGraph(
    appState: AppState,
    navigateToEventDetail: (eventId: String, slug: String) -> Unit
) {
    composable(Screen.SearchScreen.route) {
        SearchRoute(
            appState = appState,
            navigateToEventDetail = navigateToEventDetail
        )
    }
}